import React from 'react';

import { Field } from '@hrlogics/react-components/form';

import { Nullable } from '@clearverify/types';

import { SelectField } from 'src/components/finalForm';
import { VerificationRequestCreateFormFields } from 'src/constants/verificationRequest';
import { usePermissiblePurposesOptions } from 'src/hooks/permissiblePurposes';

type VerificationRequestCreateFormPermissiblePurposeFieldProps = {
  verifierId: Nullable<string>;
  disabled?: boolean;
};

export const VerificationRequestCreateFormPermissiblePurposeField: React.FC<
  VerificationRequestCreateFormPermissiblePurposeFieldProps
> = ({ verifierId, disabled }) => {
  const { permissiblePurposesOptions, isPermissiblePurposesLoading } =
    usePermissiblePurposesOptions(verifierId);

  return (
    <Field
      name={VerificationRequestCreateFormFields.permissiblePurposeId}
      component={SelectField}
      label="Permissible Purpose for request (required by FCRA)"
      options={permissiblePurposesOptions}
      fullWidth
      scrollableContent
      required
      disabled={isPermissiblePurposesLoading || disabled}
    />
  );
};
